import script from "./CoursePrice.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursePrice.vue?vue&type=script&setup=true&lang=js"

import "./CoursePrice.vue?vue&type=style&index=0&id=3207808a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3207808a"]])

export default __exports__